import script from "./SaasChannelData.vue?vue&type=script&lang=ts&setup=true&name=StockList"
export * from "./SaasChannelData.vue?vue&type=script&lang=ts&setup=true&name=StockList"

import "./SaasChannelData.vue?vue&type=style&index=0&id=514e7e78&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-514e7e78"]])

export default __exports__